import { useQuery } from "react-query";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoint from "../api/ajax-endpoints";

type currencyType = {
  currentCurrencyValue: string;
  aggregator_id: string;
};
const getTransactionsOverview = async ({
  currentCurrencyValue,
  aggregator_id,
}: currencyType) => {
  const data = await getDataWithDotNet(
    `${ajaxEndpoint.TRANSACTION_OVERVIEW}?currency=${currentCurrencyValue}&aggregator_id=${aggregator_id}`,
  );
  return data.data;
};

export default function useTransactionsOverview({
  currentCurrencyValue,
  aggregator_id,
}: currencyType) {
  return useQuery(
    [{ currentCurrencyValue, aggregator_id }, "getTransactionsOverview"],
    getTransactionsOverview,
    {
      enabled: currentCurrencyValue && aggregator_id ? true : false,
      retry: 4,
    },
  );
}
